var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFilterTaskMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0013 15.332H12.3346V13.6654H9.0013V15.332ZM3.16797 5.33203V6.9987H18.168V5.33203H3.16797ZM5.66797 11.1654H15.668V9.4987H5.66797V11.1654Z",
    fill: "#5932EA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTaskMobile);
export default __webpack_public_path__ + "static/media/filter-task-mobile.87391db42ce18416149e34330d341c50.svg";
export { ForwardRef as ReactComponent };